export default "__VITE_ASSET__D8DN$6my__"